const RowFilterCore = require("../core/RowFilterCore");
module.exports = class RowFilter extends RowFilterCore {};
